<div class="app-template-edit content">
    <header class="sticky-header">
        <div class="left-column">
            <div class="icon-header">
                <div class="icon-container">
                    <mat-icon>edit</mat-icon>
                </div>
                <h1 class="ellipsis" data-automation="edit-title">{{ 'template.edit.title' | translate }}</h1>
                <p class="desktop-only subtitle" data-automation="edit-subtitle">
                    {{ 'template.edit.subtitle' | translate }}
                </p>
            </div>
        </div>

        <div class="right-column">
            <button
                class="icon-btn x-btn-secondary"
                color="gray"
                (click)="handleCancel()"
                [disabled]="this.templateId === ''"
                data-automation="templateCancel"
            >
                <mat-icon>clear</mat-icon>
                <span class="btn-text"> {{ 'template.button.cancel' | translate }}</span>
            </button>

            <button
                class="icon-btn x-btn-primary"
                color="accent"
                aria-label="delete"
                (click)="openDeleteDialog()"
                data-automation="delete"
                [disabled]="this.templateId === ''"
            >
                <mat-icon>delete</mat-icon>
                <span class="btn-text"> {{ 'template.button.delete' | translate }}</span>
            </button>

            <button
                class="icon-btn x-btn-primary"
                color="accent"
                (click)="handleSubmit()"
                data-automation="templateSubmit"
                [disabled]="!templateForm.valid"
            >
                <mat-icon *ngIf="!isSubmitting">done</mat-icon>
                <div *ngIf="isSubmitting" class="btn-spinner">
                    <mat-spinner diameter="15"></mat-spinner>
                </div>
                <span class="btn-text"> {{ 'template.button.save' | translate }}</span>
            </button>
        </div>
    </header>

    <form #edit="ngForm" class="template-form">
        <app-template-form [mode]="mode" [templateForm]="templateForm"></app-template-form>
    </form>
</div>
